import * as ScrollMagic from 'ScrollMagic' 
import { ScrollMagicPluginIndicator} from "scrollmagic-plugins";
export default class AnchorMenu {
  constructor(element) {
    this.el = element
    this.anchorPoints = document.querySelectorAll("a[name]");
    this.activatePointModule = this.activatePointModule.bind(this);
    this.init()
  }
  
  init() {    
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
          e.preventDefault();
          document.querySelector(this.getAttribute('href')).scrollIntoView({
              behavior: 'smooth'
          });
      });
    });

    if (this.anchorPoints){
      this.activatePointModule(this.anchorPoints)      
    }
    var anchorcontroller = new ScrollMagic.Controller();
    //ScrollMagicPluginIndicator(ScrollMagic);
    var headerSceen = new ScrollMagic.Scene({
      triggerElement: this.el,
      triggerHook: 0,      
    })
    .setPin(this.el)
    .setClassToggle(this.el,"pin")    
    .addTo(anchorcontroller) 
    // .addIndicators({
    //   colorTrigger:'black'
    // })
  }

  activatePointModule(points){
    var pointcontroller = new ScrollMagic.Controller();
    points.forEach(point =>{
      let anchorLink = this.el.querySelector(`a[href^="#${point["id"]}"]`)
      let module = point.nextElementSibling;
      let moduleHeight = module.offsetHeight;    
      var anchorPoint = new ScrollMagic.Scene({
        triggerElement:module,
        duration:moduleHeight
      })
      .setClassToggle(anchorLink,"active")
      .addTo(pointcontroller) 
      
    })
    

  }


}


